import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import type { History } from "history";
import { appConfig } from "@/config";

let isAppInsightsInitialized = false;

export function initAppInsightsOnce(history: History): void {
    if (isAppInsightsInitialized) return;
    if (!canLoadAppInsights()) return;

    isAppInsightsInitialized = true;
    console.log("AI");
    loadAppInsights(history);
}

function canLoadAppInsights(): boolean {
    const isProductionBuild = process.env.REACT_APP_ENVIRONMENT === "prod";
    const hasInstrumentationKey = Boolean(appConfig.instrumentationKey);
    return isProductionBuild && hasInstrumentationKey;
}

function loadAppInsights(history: History): void {
    const reactPlugin = new ReactPlugin();
    const appInsights = new ApplicationInsights({
        config: {
            instrumentationKey: appConfig.instrumentationKey,
            extensions: [reactPlugin],
            extensionConfig: {
                [reactPlugin.identifier]: { history },
            },
        },
    });

    appInsights.loadAppInsights();
}

export function resetAppInsightsForTests(): void {
    isAppInsightsInitialized = false;
}
